import WarningIcon from '@mui/icons-material/Warning';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';

import { datePickerType } from 'portal/src/components/common/forms/FormFieldTypes';
import MonthPickerDialogForm from 'portal/src/components/common/MonthPickerDialogForm';

const fieldConf: datePickerType = {
  placeholder: 'Start Month',
  label: 'Start Month',
  name: 'syncStartDate',
  type: 'datePicker',
  required: true,
  other: {
    views: ['year', 'month'],
  },
};

const defaultSyncStartDate = new Date('January 1, 2020');

const AddToEnergyStarDialog = ({
  facilityName,
  isLoading,
  onClose,
  onSave,
  open,
  products,
}: {
  facilityName: string;
  isLoading: boolean;
  onClose: () => void;
  onSave: (syncStartDate: string) => void;
  open: boolean;
  products: string[];
}) => {
  const productNames = products?.join(', ');

  return (
    <MonthPickerDialogForm
      open={open}
      onClose={onClose}
      onSave={(month) => onSave(format(month, 'yyyy-MM-dd'))}
      isLoading={isLoading}
      maxWidth="md"
      fieldConf={fieldConf}
      defaultValue={defaultSyncStartDate}
      formId="facility-add-to-es-form"
      confirmLabel="Confirm"
    >
      <Box display="flex" justifyContent="center" mb={2}>
        <WarningIcon
          sx={{ color: 'warning.main', fontSize: '50px', alignSelf: 'center' }}
        />
      </Box>
      <Typography component="div">
        Clicking "Confirm" will:
        <ul>
          <li>
            Create an ENERGY STAR property and property use for '{facilityName}'
          </li>
          <li>Create meters for all energy and water meters</li>
          <li>
            Add all consumption data since the selected start month to ENERGY
            STAR Portfolio Manager
          </li>
          <li>Set up an ongoing sync of data</li>
          <li>
            Allow viewing of ENERGY STAR scores for relevant facilities within
            the {productNames}
          </li>
        </ul>
        Before submitting, ensure you have created all energy/water meters in
        the {productNames} and loaded all historical meter consumption data to
        increase the likelihood of receiving ENERGY STAR scores for this
        facility.
      </Typography>
      <Box mt={2}>Enter a consumption sync start month:</Box>
    </MonthPickerDialogForm>
  );
};

export default AddToEnergyStarDialog;
